import styled, { css } from 'styled-components';
import {
  AppBeforeAndAfterSliderIconArrowSolidMedium,
  AppBeforeAndAfterSliderIconArrowSolidSmall,
  AppBeforeAndAfterSliderIconArrowTailedMedium,
  AppBeforeAndAfterSliderIconCross,
  AppBeforeAndAfterSliderIconFullscreen
} from '@elfsight/icons';

const iconVariations = {
  'arrow-solid-small': {
    Component: AppBeforeAndAfterSliderIconArrowSolidSmall,
    props: {
      width: 6,
      height: 12
    }
  },
  'arrow-solid-medium': {
    Component: AppBeforeAndAfterSliderIconArrowSolidMedium,
    props: {
      width: 8,
      height: 20
    }
  },
  'arrow-tailed-medium': {
    Component: AppBeforeAndAfterSliderIconArrowTailedMedium,
    props: {
      width: 28,
      height: 28
    }
  },
  fullscreen: {
    Component: AppBeforeAndAfterSliderIconFullscreen,
    props: {
      width: 36,
      height: 36
    }
  },
  cross: {
    Component: AppBeforeAndAfterSliderIconCross,
    props: {
      width: 28,
      height: 29
    }
  }
};

interface IconProps {
  type: keyof typeof iconVariations;
  color?: string;
  strokeColor?: string;
  rotation?: number;
}

export function Icon({
  type: iconType,
  color,
  strokeColor,
  rotation = 0
}: IconProps) {
  const icon = iconVariations[iconType];

  if (!icon) {
    throw new Error(`Unknown icon "${iconType}"`);
  }

  const { Component: IconComponent, props: iconProps } = icon;

  return (
    <Container
      _iconRotation={rotation}
      _iconFill={color}
      _iconStroke={strokeColor}
    >
      <IconComponent {...iconProps} />
    </Container>
  );
}

const Container = styled.div<{
  _iconRotation?: number;
  _iconFill?: string;
  _iconStroke?: string;
}>`
  & svg {
    display: block;

    ${({ _iconRotation }) =>
      _iconRotation &&
      css`
        transform: rotate(${_iconRotation}deg);
      `};

    ${({ _iconFill, _iconStroke }) => css`
      & path {
        fill: ${_iconFill || 'transparent'};
        stroke: ${_iconStroke || 'transparent'};
      }
    `};
  }
`;
